module.exports = __webpack_public_path__ + "static/logo-c469a158616e234cf50ec91f75b68e90.png";